import { getPolicyType } from "../../../../../actions/Utilities/ConfigureAgreement";
import { useQuery } from "react-query";

export default function usePolicyType() {
  return useQuery("GetPolicyType", getPolicyType, {
    refetchOnWindowFocus: false,
  });
}
